module.exports = __webpack_public_path__ + "img/banner5.0efceb78.jpg";